export default [
  {
    name: 'Bet > Settle Win > AdjustBet',
    functionName: 'bet_settleWin_adjustBet',
  },
  {
    name: 'Bet > Settle Lose > AdjustBet',
    functionName: 'bet_settleLose_adjustBet',
  },
  {
    name: 'Bet > Settle Win 5 times > AdjustBet',
    functionName: 'bet_settleWin5Times_adjustBet',
  },
  {
    name: 'Bet > (Network) Settle Win 5 times > AdjustBet',
    functionName: 'bet_asyncSettleWin5Times_adjustBet',
  },
  {
    name: 'Bet > Jackpot Settle Win > AdjustBet',
    functionName: 'bet_jackpotSettleWin_adjustBet',
  },
  {
    name: 'Bet > Jackpot Settle Win > (Grand) Jackpot Settle Win > AdjustBet',
    functionName: 'bet_jackpotSettleWin_grandJackpotSettleWin_adjustBet',
  },
  {
    name: 'Bet > CancelBet',
    functionName: 'bet_cancelBet',
  },
  {
    name: 'CancelBet only',
    functionName: 'cancelBetOnly',
  },
  {
    name: 'CancelBet > Bet',
    functionName: 'cancelBet_bet',
  },
  {
    name: 'Place 3 bets in 3 rounds > CancelBet',
    functionName: 'bet1_bet2_bet3_cancelBet123',
  },
  {
    name: 'Bet > CancelBet 5 times',
    functionName: 'bet_cancelBet5Times',
  },
  {
    name: 'Tip',
    functionName: 'tip',
  },
  {
    name: 'Tip > CancelTip',
    functionName: 'tip_cancelTip',
  },
  {
    name: 'Tip > CancelTip 5 times',
    functionName: 'tip_cancelTip5Times',
  },
  {
    name: 'CancelTip only',
    functionName: 'cancelTipOnly',
  },
  {
    name: 'CancelTip > Tip',
    functionName: 'cancelTip_tip',
  },
  {
    name: 'Multi Bets - Place 2 bets > Settle Lose on TXN 2 > Jackpot Settle Win on TXN 1 > (Grand) Jackpot Settle Win on TXN 1 > AdjustBet',
    functionName: 'multiBets_bet1_bet2_settle2_jackpotSettleWin1_grandJackpotSettleWin1_adjustBet',
  },
  {
    name: 'Multi Bets - Place 5 bets > Settle on TXN 1 & 4 & 5 > Jackpot Settle Win on TXN 2 & 3 > AdjustBet',
    functionName: 'multiBets_bet1_bet2_bet3_bet4_bet5_settle145_jackpotSettleWin23_adjustBet',
  },
  {
    name: 'Positive Balance - Bet',
    functionName: 'positiveBalance_bet',
  },
  {
    name: 'Zero Balance - Bet',
    functionName: 'zeroBalance_bet',
  },
  {
    name: 'Negative Balance - Bet',
    functionName: 'negativeBalance_bet',
  },
]
